module.exports = __webpack_public_path__ + "static/img/icon_jr.c7e77211.png";